import { gql } from '@apollo/client';

const TaxProfileTemplateInfo = gql`
  fragment TaxProfileTemplateInfo on TaxProfileTemplate {
    id
    approvedAt
    approvedById
    commercialDescription
    effectiveAt
    evidenceReference
    expiresAt
    fixedUnitPrice
    fulfillmentSummary
    jurisdictionRestrictions
    name
    productFamily
    providerRequirements
    reviewAt
    state
    supersedesId
    templateKey
    treatment
    versionNumber
    taxComponentTemplates {
      id
      allocationType
      allocationValue
      description
      effectiveAt
      evidenceReference
      expiresAt
      identifier
      position
      taxjarProductTaxCode
    }
  }
`;

export default TaxProfileTemplateInfo;
